import async from "async";

const _ = require('lodash');
const moment = require('moment');

const yesterdayISO = moment().subtract(1, "days").format("YYYY-MM-DD")
const todayISO = moment().format("YYYY-MM-DD")


export const jobs = () => [
    {
        name: 'purgeAuditData',
        title: 'Purge user logs',
        single: true,
        execute: async function(context, callback) {
            try {
                const modelId = _.get(context, 'groupModel.model.id');
                const groupModelId = _.get(context, 'groupModel.id');

                console.log('model id', modelId);
                console.log('group model id', groupModelId);

                if (!modelId) {
                    return callback(null, { message: "Purge job skipped: No model context found." });
                }

                if (!groupModelId) {
                    return callback(null, { message: "Purge job skipped: No group model context found." });
                }

                const collectionName = `${_.lowerCase(modelId)}.auditLog`;
                const oneMonthAgo = moment().subtract(1, 'months').toDate();
                const query = { date: { $lt: oneMonthAgo }, groupModel: new global.ObjectID(groupModelId) };

                const result = await global.db.collection(collectionName).deleteMany(query);

                callback(null, { message: `Successfully purged ${result.deletedCount} logs from ${collectionName} older than one month.` });
            } catch (e) {
                const modelId = _.get(context, 'groupModel.model.id', 'N/A');
                console.error(`Error purging audit logs for model ${modelId}:`, e);
                callback(e);
            }
        }
    }
];

export const entities = () => [
    {
        name: 'AuditLogAction',
        type: 'static',
        fields: [
            { path: 'id', type: 'string' },
            { path: 'name', type: 'string' }
        ],
        objects: [
            { id: 'C', name: 'Création' },
            { id: 'R', name: 'Lecture' },
            { id: 'U', name: 'Mise à jour' },
            { id: 'D', name: 'Suppression' },
            { id: 'L', name: 'Liste' }
        ]
    },
    {
        name: 'AuditLog',
        fields: [
            {path: 'date', type: 'date', dateFormat: 'YYYY-MM-DD HH:mm:ss'},
            'requestId',
            {
                type: 'User',
                nullable: true,
                link: {oppositeField: {link: {deleteType: "cascade"}}}
            },
            {type: 'Group', nullable: true},
            {type: 'GroupModel', nullable: true},
            {path: 'moduleName', fieldPath: ['module.tKey', 'module.name'], $f: (object, context, callback) => callback(null, _.get(object, 'module.tKey') || _.get(object, 'module.name'))},
            {path: 'device', type: 'object'},
            {path: 'browser', fieldPath: ['device.client.name'], $f: (object, context, callback) => callback(null, _.get(object, 'device.client.name'))},
            {path: 'deviceName', fieldPath: ['device.device.brand'], $f: (object, context, callback) => callback(null, _.get(object, 'device.device.brand'))},
            'entityUrl',
            {path: 'action', type: 'AuditLogAction'},
            'method',
            'ip',
            'ua',
            {path: 'success', type: 'boolean'},
            {path: 'success'},
            {path: "errorMessage", fieldPath: ['error.message'], $f: (object, context, callback) => callback(null, _.get(object, 'error.message'))}
        ]
    }
];

export const modules = () => [
    {
        tKey: 'Audit Logs',
        object: 'AuditLog',
        category: {
            path: 'administrator',
            icon: 'admin'
        },
        newable: false,
        removable: false,
        updatable: false,
        manualFilters: true,
        protectedExport: true,
        defaultSortBy: 'date',
        defaultSortDirection: 'DESC',
        viewMap: {
            dt: [
                {path: 'date', width: 150},
                {path: 'user', display: 'name', width: 200},
                {path: 'moduleName', tKey: 'module', translate: true, width: 200},
                {path: 'action', width: 100, translate: true},
                {path: 'browser', disabled: true},
                {path: 'deviceName', tKey: 'device', disabled: true},
                {path: 'success', width: 100, type: 'boolean'},
                {path: "errorMessage", tKey: 'message', translate: true}
            ]
        },
        filters: [
            {
                path: 'period',
                title: 'period',
                type: 'dateRange',
                clearable: false,
                default: [yesterdayISO, todayISO],
                client: true,
                query: function(context) {
                    const period = _.get(context, 'data.period');
                    const [startDate, endDate] = Array.isArray(period)
                        ? period
                        : [_.get(period, 'startDate'), _.get(period, 'endDate')];

                    const query = {};
                    if (startDate) {
                        query.$gte = moment(startDate).startOf('day').toDate();
                    }
                    if (endDate) {
                        query.$lte = moment(endDate).endOf('day').toDate();
                    }
                    return _.isEmpty(query) ? {} : {date: query};
                }
            },
            {
                path: 'users',
                title: 'users',
                object: 'User',
                display: 'name',
                client: true,
                type: 'tags',
                filters: ["isInGroupModel"],
                query: function(context) {
                    const users = _.get(context, 'data.users');
                    if (users && users.length) {
                        return { user: { $in: users.map(u => new global.ObjectID(u.id)) } };
                    }
                    return {};
                }
            },
            {
                path: 'action',
                title: 'action',
                object: 'AuditLogAction',
                display: 'name',
                client: true,
                translate: true,
                query: function(context) {
                    const actionId = _.get(context, 'data.action.id');
                    if (actionId) {
                        return { action: actionId };
                    }
                    return {};
                }
            }
        ]
    }
];
